var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('data-table',{ref:"permitsduetable",attrs:{"table-ref":"permitsduetable","title":"Permits","icon":"fa fa-list","hide-org-badge":"","show-search":false,"url":'/permits/site/' + _vm.rowData.id,"fields":_vm.fields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }